/**
 * API version identifiers shared by the AI assistants, query editors and workflow node
 * editors. Mirrors InsyteWeb_Domain.API.ApiVersions on the server (release 26.3):
 *  - LATEST_API_VERSION is the only version the AI authors in and the version stamped on
 *    newly created artifacts / workflow nodes.
 *  - LEGACY_EXECUTION_API_VERSION is what an OData-executing artifact runs against when it
 *    carries no version of its own (previously authored customizations, grids, exports).
 */
export const API_VERSION_V2 = 'v2';
export const API_VERSION_V3 = 'v3';

export const LATEST_API_VERSION = API_VERSION_V3;
export const LEGACY_EXECUTION_API_VERSION = API_VERSION_V2;

/** Canonical lower-case version, or `fallback` when the value is blank/unknown. */
export const normalizeApiVersion = (value, fallback = LATEST_API_VERSION) => {
  const v = (value ?? '').toString().trim().toLowerCase();
  return v === 'v1' || v === API_VERSION_V2 || v === API_VERSION_V3 ? v : fallback;
};

/**
 * Workflow metadata versioning: the workflow graph has no version, nodes do. A node,
 * custom setting or card carries `metadataVersion` in its config; absent means it was
 * authored before versioning and keeps reading the legacy (v2) entity/field metadata.
 * Only the versions WorkflowMetadataService serves (v2/v3) are meaningful here.
 */
export const METADATA_VERSION_KEY = 'metadataVersion';
export const LEGACY_METADATA_VERSION = API_VERSION_V2;
/** Versions workflow metadata is served for (mirrors ApiVersions.WorkflowVersions). */
export const WORKFLOW_METADATA_VERSIONS = [API_VERSION_V2, API_VERSION_V3];

/** The metadata version serving a given API version (v1/absent/unknown collapse to legacy v2). */
export const toMetadataVersion = (apiVersion) => (
  normalizeApiVersion(apiVersion, LEGACY_METADATA_VERSION) === API_VERSION_V3 ? API_VERSION_V3 : LEGACY_METADATA_VERSION
);

/** Effective metadata version of a node/setting/card config (absent or unknown = legacy v2). */
export const getNodeMetadataVersion = (config) => toMetadataVersion(config?.[METADATA_VERSION_KEY]);
